import axios from 'axios';
import API from '../../../src/config_api'
import { FETCH_ASSIGN_DATA_REQUEST, FETCH_ASSIGN_DATA_SUCCESS, FETCH_ASSIGN_DATA_FAILURE } from './AssignTypes'
export const fetchDataRequest = () => {
    return {
        type: FETCH_ASSIGN_DATA_REQUEST
    }
}
export const fetchDataSuccess = data => {
    return {
        type: FETCH_ASSIGN_DATA_SUCCESS,
        payload: data
    }
}
export const fetchDataFailure = error => {
    return {
        type: FETCH_ASSIGN_DATA_FAILURE,
        payload: error
    }
}

export const fetchData = () => {
    return (dispatch) => {
        dispatch(fetchDataRequest());
        let formData = new FormData();
        const userID = localStorage.getItem('token');
        const ID = userID.split('@');
        formData.append('app_id', ID[0])
        axios({
                method: 'post',
                url: API.Permit,
                data: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                mode: 'no-cors',
            })
            .then(res => {
                if (res.data.status === 'success') {
                    const data = res.data;

                    dispatch(fetchDataSuccess(data))

                } else {
                    const error = res.data.message;
                    dispatch(fetchDataFailure(error))
                }
            });
    }
}